<template>
  <BackendTable :query="query" :endPoint="'users/'" @pageChange="(p) => $emit('pageChange', p)">
    <template v-slot="{ row }">
      <b-table-column field="image" label="Image" width="40" numeric>
        <img :src="row.profile.image ? row.profile.image.file : null" />
      </b-table-column>

      <b-table-column field="name" label="Name">
        {{ `${row.profile.first_name} ${row.profile.last_name || ''}` }}
      </b-table-column>


      <b-table-column field="employment_availability" label="Available in">
        {{ row.profile.employment_availability || '' }}
      </b-table-column>

      <b-table-column field="current_country" label="Current country">
        {{ row.profile.current_country || '' }}
      </b-table-column>

      <b-table-column field="desired_employment_positions" label="Desired Employment">
        <b-tag rounded type="is-info"
          v-for="p in row.profile.desired_employment_positions"
          :key="p">
          {{p}}
        </b-tag>
      </b-table-column>

      <b-table-column centered label="Details">
        <router-link
          class="button is-primary"
          tag="a"
          :to="{name:'user-details', params: {id: row.id}}">
          Details
        </router-link>
      </b-table-column>
    </template>
  </BackendTable>
</template>

<script>
import BackendTable from './BackendTable';


export default {
  components: {
    BackendTable,
  },

  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },

};
</script>
